//client\src\dnd\config\hardcodedMarkers.js
export const HARDCODED_MARKERS = {
  108: { x: 1028, y: 938, colour: "#3b82f6", label: "Player", reach: 5 },
  111: { x: 147, y: 553, colour: "#3b82f6", label: "Player", reach: 5 },
  110: { x: 1227, y: 417, colour: "#3b82f6", label: "Player", reach: 5 },
};